import React,{useContext,useEffect,useState} from "react";
import Header from "components/global/header";
import Footer from "components/global/footer";
import { connect } from "react-redux";
import userActions from "redux/modules/user/actions";
import BreadCrumbsComponent from "components/breadcrumbs/breadcrumbs";
import _ from "lodash";
import Alerts from "components/global/alerts";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "context/context";
// import { useMilestones } from "redux/modules/milestone/hooks";
import { API_ENDPOINT } from "configs/api";
import AlertBar from "components/global/alert-bar";
import { Link } from "react-router-dom";
import { SubscriptionContext } from "context/subscription";
import webIcon from "assets/images/global-site.webp"
import GlobeIconSVG from "assets/svg/globe-icon";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDialogHook } from "utils/customhooks";
import PremiumModal from "components/subscription/pop-up-premium";
import FooterPremium from "components/subscription/footer-premium";


const Layout = (
  {
    children,
    title = null,
    userData,
    setUserData,
    breadscrumbs = {},
    handleScroll = () => {},
    contentRef = null,
    containerStyle = "",
    isYourProfile = false,
    allowBanner = false,
    setSelectedTab = ()=>{}
  },
  ref
) => {
  // const { total: totalMilestones } = useMilestones();
  const query = useQuery();
  const history = useHistory();
  const {t} = useTranslation();
  const { 
      subscription,
      showPremiumPopUp,
      setPremium,
      viewPremiumBar,
      closeAlertBar,
      setCloseBar,
      setPremiumFooter,
      isSubscribed
    } = useContext(SubscriptionContext);
  const { metaData } = useContext(Context);
  const [viewPublic, setViewPublic] = useState(false);
  const modalPremiumSub = useDialogHook(PremiumModal);

  const checkSubscription = isYourProfile && subscription?.name === 'Free Account' && (userData?.user.reg_status!='freemium' && userData?.user.reg_status!='lifetime');

  useEffect(()=>{
      if(showPremiumPopUp && (checkSubscription)){
        modalPremiumSub({fromLogin:true},(callBack)=>{})
      }
      let showHidePreMilestone = JSON.parse(localStorage.getItem('premium-bar') ?? 'true');
      if(showHidePreMilestone === null || showHidePreMilestone === undefined){
        setPremium(true)
      }else{
        setPremium(JSON.parse(showHidePreMilestone))
      }

      let showHidePreFooter = JSON.parse(localStorage.getItem('premium-footer') ?? 'true');
      if(showHidePreFooter === null || showHidePreFooter === undefined){
        setPremiumFooter(true)
      }else{
        setPremiumFooter(JSON.parse(showHidePreFooter))
      }
  },[showPremiumPopUp,checkSubscription])

  useEffect(() => {
    if (query?.viewPublic) {
      setViewPublic(true);
      setCloseBar(true);
    }else{
      setCloseBar(true);
      setViewPublic(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const checkDomain = () => {
      const currentDomain = window.location.hostname; 
      if (currentDomain.includes('app.milestonespage.com') || API_ENDPOINT.includes('app.milestonespage.com')) {
        return false;
      } else {
        return true;
      }
    };
  return (
    <HelmetProvider>
      <Helmet>
          {process.env.REACT_APP_ENV !== 'prod' && <meta name="robots" content="noindex" />}
          {/* <title>{title} - Milestones Page</title>  */}
          <title>{metaData.title || 'Milestones Page'}</title>
          <meta name="description" content={metaData.description || 'Milestones Page - Your creative history in one place'}/>
          <meta property="og:url" content={metaData.url || 'https://milestones.demosite.ninja/'}/>
          <meta property="og:type" content="website"/> 
          <meta property="og:title" content={metaData.title || 'Milestones Page'}/> 
          <meta property="og:description" content={metaData.description || 'Milestones Page - Your creative history in one place'}/> 
          <meta property="og:image" content={metaData.imageUrl || 'https://www.creativefabrica.com/wp-content/uploads/2021/04/05/Photo-Image-Icon-Graphics-10388619-1-580x386.jpg'}/>
          <meta name="twitter:card" content="summary_large_image"/> 
          <meta property="twitter:domain" content={metaData.url || 'https://milestones.demosite.ninja/'}/> 
          <meta property="twitter:url" content="https://milestones.demosite.ninja/customer-OnnB/profile/3"/> 
          <meta name="twitter:title" content={metaData.title || 'Milestones Page'}/> 
          <meta name="twitter:description" content={metaData.description || 'Milestones Page - Your creative history in one place'}/> 
          <meta name="twitter:image" content={metaData.imageUrl || 'https://www.creativefabrica.com/wp-content/uploads/2021/04/05/Photo-Image-Icon-Graphics-10388619-1-580x386.jpg'}>
          </meta>
      </Helmet>
      <div className="h-screen lg:flex w-full relative">
        <div
          ref={contentRef}
          // className="h-screen lg:static lg:overflow-y-auto lg:overflow-x-hidden lg:flex-grow bg-siteBg scroll-smooth custom-scroll"
          className={`h-screen lg:flex-grow bg-siteBg scroll-smooth custom-scroll ${containerStyle}`}
          onScroll={handleScroll}>
          <Header title={title} userData={userData} setUserData={setUserData} setSelectedTab={setSelectedTab} isYourProfile={isYourProfile}/>
          {
            (closeAlertBar && allowBanner) &&
            <div>
              {
                (isYourProfile && viewPremiumBar) && subscription?.name === 'Free Account' && (userData?.user.reg_status!='freemium' && userData?.user.reg_status!='lifetime') ?
                <AlertBar
                content={() => {
                  return(
                    <span class="text-verified font-semibold">
                      {t('upgradeToPremium')}  
                      <span className="ml-1 hover:text-gray underline font-semibold cursor-pointer"
                          onClick={()=>{modalPremiumSub({},(callBack)=>{});setPremiumFooter(false)}}
                        >
                         {t('clickHere')}
                      </span>
                    </span>
                  )
                }}
                onClose={()=>{setCloseBar(false); setPremium(false); localStorage.setItem('premium-bar', JSON.stringify(false))}}
                showBtnExit={true}
              />: 
              _.isEmpty(userData?.profile) ?
              <AlertBar
                content={() => {
                  return(
                    <span class="text-verified">
                      {t('createYourMilestones')} - 
                      <Link to="/sign-up" className="ml-1 hover:text-gray font-semibold">
                        {t('clickHere')}
                      </Link>
                    </span>
                  )
                }}
                onClose={()=>setCloseBar(false)} 
              />
              : viewPublic ?
              <AlertBar
                content={() => {
                  return(
                    <span class="text-verified">
                      <GlobeIconSVG className="w-[25px] inline-block mr-1" />
                      {t('publicViewMessage')}
                    </span>
                  )
                }}
                onClose={()=>{
                  const url = new URL(window.location.href);
                  url.searchParams.delete('viewPublic');
                  history.push(url.pathname + url.search,
                    {
                      viewPublic: false,
                      viewPublicFilter: false
                    }
                  );
                  setCloseBar(false)}
                } 
                onCloseText={t('exit')}
              />: null
              }
              
            </div>
          }
          {!_.isEmpty(breadscrumbs) && (
            <BreadCrumbsComponent
              title={breadscrumbs.title}
              subtitle={breadscrumbs.subtitle}
              showBanner={breadscrumbs.showBanner}
              pageName={title}
              parent={breadscrumbs.parent}
              parentUrl={breadscrumbs.parentUrl}
              currentUrl={breadscrumbs.currentUrl}
            />
          )}
          
          
          {title !== "Verify Account" &&
            !userData?.profile?.id3_verified &&
            userData?.profile?.total_milestones >= 10 && checkDomain() &&
            isYourProfile && <Alerts userData={userData}/>}
          <main className="main-wrapper mx-auto flex flex-1 bg-siteBg">
            {children}
          </main>
          {
          (((subscription?.name === 'Free Account' || subscription === null) && window.location.pathname !== "/sign-up") && !isSubscribed) && 
            <div className={`fixed bottom-0 left-0 w-full z-50`}>
              <FooterPremium
                shshowSecondPremow = {true}
                isFromLandingPage = {true}
                />
            </div>
          }
          <Footer />
        </div>
      </div>
    </HelmetProvider>
  );
};

const useQuery = () => {
  const location = useLocation();
  const state = location?.state ?? {};

  return React.useMemo(() => state, [state]);
};

const mapStateToProps = (state) => {
  return {
    userData: state.user.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUserData: (params) => {
      dispatch(userActions.setUserData(params));
    },
  };
};

const LayoutComponent = React.forwardRef(Layout);
export default connect(mapStateToProps, mapDispatchToProps)(LayoutComponent);
